// extracted by mini-css-extract-plugin
export default {"error":"ErrorMessage-module__error___3AYPA"};